function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "c4619dmx4a",
  d: "M11.818 3c3.586 0 5.14 2.029 5.815 3.789l.11.307.093.299.078.287.064.274.049.253h.848c.621 0 1.125.496 1.125 1.123v10.406c0 .62-.496 1.122-1.125 1.122H5.125C4.504 20.86 4 20.365 4 19.738V9.332c0-.62.496-1.123 1.125-1.123h.794l.007-.05.036-.247.046-.262.028-.135.065-.279.079-.287.094-.294C6.872 4.928 8.323 3 11.818 3zM18.7 9.509H5.3V19.56h13.4V9.509zm-6.514 2.003c1.284 0 2.326 1.04 2.326 2.325 0 1.038-.68 1.916-1.618 2.216l-.001 1.32h-1.414v-1.32c-.939-.299-1.619-1.178-1.619-2.216 0-1.284 1.042-2.325 2.326-2.325zm0 1.116c-.668 0-1.21.541-1.21 1.21 0 .667.542 1.209 1.21 1.209.668 0 1.21-.542 1.21-1.21 0-.668-.542-1.21-1.21-1.21zM11.818 4.3c-2.019 0-3.23.71-3.945 1.958-.302.527-.496 1.113-.604 1.693l-.012.074h9.41l-.053-.203c-.09-.317-.21-.644-.364-.966l-.121-.24C15.34 5.144 14.014 4.3 11.819 4.3z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-48 -275) translate(32 255) translate(16 20)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "9m95b801gb",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#c4619dmx4a"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  fillRule: "nonzero",
  xlinkHref: "#c4619dmx4a"
}), /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  mask: "url(#9m95b801gb)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0H24V24H0z",
  transform: "matrix(1 0 0 -1 0 24)"
}))))));

function SvgIconPassword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPassword);
export default __webpack_public_path__ + "static/media/icon-password.0aea2a1a.svg";
export { ForwardRef as ReactComponent };